/**
 * Bộ đếm thời gian trang THẬT SỰ hiển thị — cách GA4 đo "engagement time".
 *
 * Cố tình KHÔNG tự đọc đồng hồ: mốc thời gian do chỗ gọi truyền vào, nhờ vậy test được trong
 * môi trường node (vitest của repo này không có DOM).
 *
 * Và cố tình KHÔNG có hẹn giờ định kỳ: Google khuyến cáo không ping đều đặn vì tạo ra phiên không
 * bao giờ chết và thổi phồng thời lượng trung bình.
 */
export interface EngagementCounter {
  /** Trang chuyển sang hiển thị. */
  onVisible(atMs: number): void;
  /** Trang chuyển sang ẩn. Trả về số mili-giây tích luỹ và đặt lại bộ đếm. */
  onHidden(atMs: number): number;
  /** Lấy phần tích luỹ mà không cần đợi ẩn tab — dùng lúc rời trang. */
  takePending(atMs: number): number;
}

export const createEngagementCounter = (): EngagementCounter => {
  let visibleSince: number | null = null;
  let accumulated = 0;

  /** Chốt sổ phần đang chạy. Mốc lùi về quá khứ thì bỏ qua thay vì cộng số âm. */
  const settle = (atMs: number) => {
    if (visibleSince === null) return;
    const elapsed = atMs - visibleSince;
    if (elapsed > 0) accumulated += elapsed;
    // Nếu elapsed <= 0 (đồng hồ lùi), giữ nguyên visibleSince để lần chốt sổ kế tiếp
    // không tính dư một khoảng ảo. Nếu gán lùi sẽ phồng số như bug đếm trùng.
    if (elapsed > 0) visibleSince = atMs;
  };

  const take = () => {
    const value = accumulated;
    accumulated = 0;
    return value;
  };

  return {
    onVisible(atMs) {
      // Chốt sổ phần đang tích luỹ trước khi ghi đè visibleSince. React StrictMode gọi
      // effect hai lần ở dev, và sau này nếu có event focus thì onVisible cũng xảy ra lặp.
      // Bộ đếm phải chịu được gọi lặp mà không mất thời gian.
      settle(atMs);
      visibleSince = atMs;
    },
    onHidden(atMs) {
      // Chốt sổ và gửi đi. PHẢI reset accumulated kể từ lần gửi này, bởi vì hook sẽ gửi
      // server ở mỗi lần ẩn tab. Nếu không reset, server sẽ đếm trùng:
      // - lần 1 gửi 3000, server cộng 3000
      // - lần 2 gửi 7000 (chứa cả 3000 cũ), server cộng 3000+7000=10000 (sai, phải 7000)
      settle(atMs);
      visibleSince = null;
      return take();
    },
    takePending(atMs) {
      settle(atMs);
      return take();
    },
  };
};
